
import { Component, Vue, Prop } from "vue-property-decorator";
import Joke from "../model/joke";

@Component
export default class JokeView extends Vue {
  @Prop() private joke!: Joke;
  @Prop() private loading!: boolean;
}
